export enum PaymentMethod {
  PayPal = 'paypal',
  GooglePay = 'googlepay',
  ApplePay = 'applepay'
}

export interface IPaypalOrderData {
  order_id: string
  payment_method: PaymentMethod
}

export interface IPaypalOrderResponse {
  status: string
  message?: string
}
